export default __webpack_public_path__ + "static/media/champagne.12ae943e.svg";